import React from 'react'
import PropTypes from 'prop-types'
import { EmptyMessageWrapper, ParallaxIcon, Text } from './component.styles'

const EmptyMessage = ({ text }) => (
  <EmptyMessageWrapper>
    <ParallaxIcon />
    <Text>{text}</Text>
  </EmptyMessageWrapper>
)

EmptyMessage.propTypes = {
  text: PropTypes.string,
}

export default EmptyMessage
